<template>
  <div class="select-lang">
    <b-navbar-nav>
      <b-nav-item-dropdown right>
        <b-button slot="button-content" variant="link" class="locale-item" :style="{ width: 'min-content' }">
          &nbsp;&nbsp;{{ currentLocale.toUpperCase() }}
        </b-button>
        <b-dropdown-item
          v-for="locale in locales"
          :key="`locale${locale}`"
          @click="setLanguage(locale)"
          class="locale-item"
        >
          &nbsp;&nbsp;&nbsp;&nbsp;{{ locale.toUpperCase() }}
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
  </div>
</template>

<script>
    import langIcon from '../assets/images/flags/language.png'

    export default {
      name: 'SelectLang',
      data () {
        return {
          'lang': langIcon
        }
      },
      computed: {
        locales () {
          return this.$i18n.locales()
        },
        currentLocale () {
          return this.$i18n.locale()
        }
      },
      methods: {
        setLanguage (locale) {
          this.$cookie.set('locale', locale)
          this.$i18n.set(locale)
        }
      }
    }
</script>

<style  lang="scss" rel="stylesheet/scss">
  @import '../assets/styles/colors.scss';

  .select-lang{
    height: fit-content;
    position: absolute;
    z-index: 1000;
    a{
      background-color: transparent !important;
      margin-bottom: 5px;
      padding: 0 15px 0 8px !important;

      .locale-item{
        font-weight: 700;
        text-shadow: #cdcdcd 1px 1px 1px;
        color: #EC8409;

        @media (min-width: 992px ) {
          color: #fff;
        }

        @media (min-width: 1200px ) {
          color: #00839E;
        }
        &:hover, &:focus{
          outline: none;
          text-decoration: none;
        }
      }
      &:after{
        margin-left: 0;

        color: #EC8409;

        @media (min-width: 992px ) {
          color: #fff;
        }

        @media (min-width: 1200px ) {
          color: #00839E;
        }
      }
    }
    .dropdown-item{
      color: $dark-orange;
      font-weight: 500;

      &:hover, &:focus{
        outline: none;
        text-decoration: none;
      }
    }

    @media (max-width: 576px) {
      top: 0px !important;
      a{
        background-color: transparent;
        color: $dark-orange !important;
        &:after{
          color: $dark-orange;
        }
        .locale-item {
          color: $dark-orange !important;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/SelectLang.vue